/**
 * Definición global de comisiones del sistema.
 * Estas comisiones se aplican a las transacciones de promos y changas.
 */
export const COMMISSIONS = {
  SYSTEM_COMMISSION_RATE: 0.01, // 1% para el sistema
  HUNTER_COMMISSION_RATE: 0.03, // 3% para el autor del promo (cazador) - 1% trasladado al delivery
};

/**
 * Calcula el monto de comisión basado en un subtotal.
 */
export function calculateCommission(amount: number, rate: number): number {
  return amount * rate;
}
